// extracted by mini-css-extract-plugin
export var infoRow = "_rg-2";
export var labelContainer = "_rg-0";
export var rightInfo = "_rg-1";